export default __webpack_public_path__ + "static/media/Inter.b559a93b.ttf";